<template>
    <div class="search-listing hotel-listing loading-filters">
      <div class="flex-items">
        <div class="details-col">
          <div class="details-container">

            <div class="image">
              <div class="square-full"></div>
            </div>

            <div class="details">
              <div class="heading"></div>
              
              <div class="space"></div>

              <div class="med"></div>
              <div class="med"></div>

              <div class="long"></div>
            </div>
          </div>
        </div>

        <div class="price-col" v-if="!hidePrice">
        </div>
      </div>
    </div>

</template>

<script>

export default {
  name: 'LoadingHotelListing',

  props: {
    hidePrice: Boolean
  }
}
</script>